
export enum PageVersionTypeEnums {
  /** 最初老版本 */
  OLDVERSION = '001',
  /** 营销换图abtest版本 */
  NEW_VERSION_WITHAB = '101',
  /** 新版本-带营销元素的新图版本 */
  NEWVERSION = '002',
  /** 新版本-带营销元素-并带登录模块 */
  NEWVERSIONWITHLOGIN = '003',
  /** 新版本（加强臻有钱品牌宣传）-带营销元素的新图版本 */
  BRANDVERSION = '004',
  /** 新版（加强臻有钱品牌宣传）-带营销元素的新图版本 */
  BRANDVERSIONWITHLOGIN = '005',
  /** 新版（加强臻有钱品牌宣传）- 需要登录并补充资料 */
  BRAND_VERSION_WITHLOGIN_AND_INFO = '006',
  /** 新短链外投未安装 app 跳转页，直接下载 */
  SMSDOWNLOAD_HELLO_BIKE = '007',
  /** 新版（加强臻有钱品牌宣传）- 需要登录并补充资料-android一进页面不尝试马上打开 */
  BRANDVERSIONWITHLOGINANDINFO_WITHOUT_ANDROIDJUMP = '008',
  /** 饿了么专属版本 */
  BRANDVERSIONWITHELE = '009',
  // 以下3个版本为新增：http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=330709359
  /** 新版营销落地页，去除哈啰标识，按钮文案调整为下载app申请额度 */
  BRAND_VERSION_NOLGOO = '010',
  /** 005版本功能，页面拆为分屏处理，按钮文案调整为下载app查看额度 */
  BRAND_VERSION_DOWNLOAD = '011',
  /** 008版本功能上，角标变更, 提示用户发券 */
  BRAND_VERSION_COUPON = '012',
  /** 008版本功能上，底部增加风险提示 */
  BRAND_VERSION_RISK = '013',
  /** 百度信息流投放 */
  BRAND_VERSION_BAIDU = '014',
   /** 权益露出版本 */
  RIGHT_VERSION = '015',
  /** 013版本的基础上，顶部背景图片调整&利率描述文案调整 */
  BRAND_VERSION_RISK_BG = '016',
  /** 在014的版本上去除利率描述区 */
  BRAND_VERSION_BAIDU_017 = '017',
  /** 在016的基础上改顶部图片 */
  BRAND_VERSION_RISK_BG_018 = '018',
  /** 基于005的版本， 删除该逻辑：针对IOS端，登录后使用scheme尝试唤起哈啰app */
  BRANDVERSIONWITHLOGIN_019 = '019',
  /** 基于017的版本，字节头条渠道 */
  BRAND_VERSION_BYTEDANCE_020 = '020',
  /** 基于017的版本，腾讯-广点通 */
  BRAND_VERSION_TENCENT_021 = '021',
  /** 唤起哈臻快app营销落地页： */
  EVOKE_APP_MARKET_RECHARGE = '022',
  /** 臻有钱-微信小程序-短信营销落地页： */
  EVOKE_APP_MARKET_FINANCE_WX_MP = '023',
  /** 小贷主体-字节： */
  FINANCE_MAIN_BYTEDANCE = '024',
  /** 一键登录营销落地页-字节： */
  BRAND_AUTO_LOGIN_BYTEDANCE = '025',
  /** 一键登录营销落地页-广点通： */
  BRAND_AUTO_LOGIN_TENCENT = '026',
  /** 饿了么半流程专属版本 */
  NOT_CALL_WHEN_ENTER_ELM = '027',
  /** 基于004版本，百信下载页版本 */
  BAI_XIN_DOWNLOAD_PAGE = '028',
  /** 基于018版本 修改底综合年化利率文案 */
  BRAND_VERSION_TENCENT_029 = '029',
  /** 唤起记账app营销落地页： */
  EVOKE_APP_MARKET_SKZHENXH = '030',
}

/** 登录回调，处理方式 */
export enum CallBackActionEnum {
  /** 直接下载app */
  DOWNLOAD = '1',
  /** 跳转资料填写页 */
  GO_TO_INFO_PAGES = '2'
}

/** 页面营销唤起-app类型：哈啰app、哈臻快app、臻有钱-微信小程序、记账app */
export enum EvokeAppTypeEnums {
  /** 哈啰app */
  HELLO_BIKE = 'hello_bike',
  /** 哈臻快app */
  RECHARGE = 'recharge',
  /** 臻有钱-微信小程序 */
  FINANCE_WX_MP = 'finance_wx_mp',
  /** 记账app */
  SKZHENXH = 'skzhenxh'
}
